import _slicedToArray from "C:\\Users\\benja\\Documents\\projects\\dev\\jam-pad-2\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import * as map from './map.js';
import * as string from './string.js';
/* istanbul ignore next */
// @ts-ignore

export var isNode = typeof process !== 'undefined' && process.release && /node|io\.js/.test(process.release.name);
/* istanbul ignore next */

export var isBrowser = typeof window !== 'undefined' && !isNode;
/**
 * @type {Map<string,string>}
 */

var params;
var args = [];

var computeParamsNode = function computeParamsNode() {
  if (params === undefined) {
    params = map.create();
    var pargs = process.argv;
    var currParamName = null;
    /* istanbul ignore next */

    for (var i = 0; i < pargs.length; i++) {
      var parg = pargs[i];

      if (parg[0] === '-') {
        if (currParamName !== null) {
          params.set(currParamName, '');
        }

        currParamName = parg;
      } else {
        if (currParamName !== null) {
          params.set(currParamName, parg);
          currParamName = null;
        } else {
          args.push(parg);
        }
      }
    }
  }

  return params;
};
/* istanbul ignore next */


var computeParamsBrowser = function computeParamsBrowser() {
  if (params === undefined) {
    params = map.create() // eslint-disable-next-line no-undef
    ;
    (location.search || '?').slice(1).split('&').forEach(function (kv) {
      if (kv.length !== 0) {
        var _kv$split = kv.split('='),
            _kv$split2 = _slicedToArray(_kv$split, 2),
            key = _kv$split2[0],
            value = _kv$split2[1];

        params.set("--".concat(string.fromCamelCase(key, '-')), value);
        params.set("-".concat(string.fromCamelCase(key, '-')), value);
      }
    });
  }

  return params;
};
/* istanbul ignore next */


var computeParams = isNode ? computeParamsNode : computeParamsBrowser;
/**
 * @param {string} name
 * @return {boolean}
 */

export var hasParam = function hasParam(name) {
  return computeParams().has(name);
};
/* istanbul ignore next */

/**
 * @param {string} name
 * @param {string} defaultVal
 * @return {string}
 */

export var getParam = function getParam(name, defaultVal) {
  return computeParams().get(name) || defaultVal;
}; // export const getArgs = name => computeParams() && args

export var production = getParam('production', '0') !== '0';